import { User, UserStatus, UserType } from 'module/api/user/types';
import keyBy from 'lodash/keyBy';
import { useGetAllActiveNativeUsersQuery } from 'queries/member';
import { useMemo } from 'react';

export function useGetAllActiveNativeUsers(): User[] {
  const { data: membersData } = useGetAllActiveNativeUsersQuery();

  return useMemo(() => {
    const data = (membersData ?? []).filter(
      (x) =>
        x.userType === UserType.Native && x.userStatus !== UserStatus.Inactive,
    );

    return data;
  }, [membersData]);
}

export function useGetAllNativeActiveUsersMap(): Record<number, User> {
  const { data: membersData } = useGetAllActiveNativeUsersQuery();

  return useMemo(() => {
    const users = (membersData ?? []).filter(
      (user) =>
        user.userStatus !== UserStatus.Inactive &&
        user.userType === UserType.Native,
    );

    return keyBy(users, 'userId');
  }, [membersData]);
}
